import { Team } from '@/types/auth'
import { ITeamTheme } from '@/types/branding'
import { isValidCssColor } from '@/utils/colors'

/**
 * Only file that knows which color field represents a team's brand color.
 * `colors.primary` isn't on every `Team` — the profile service fills it from
 * Sport on write and refreshes it on every read (PRO-467/468), but an entry
 * whose `_id` never resolved there comes back without colors.
 *
 * This is the single choke point before the color reaches a `<style>` tag
 * (resolveThemeStyles → buildTeamGradient → AppProvider). The value must be a
 * validated CSS color literal — a raw string here becomes a CSS-injection
 * sink. Anything that isn't a strict hex/named color is dropped (no theme).
 */
export function toTeamTheme(team: Team | null): ITeamTheme | null {
  if (!team) return null

  const color = team.colors?.background ?? team.colors?.primary
  if (!isValidCssColor(color)) return null

  return { color }
}
